var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.place === 'overlay')?_c('div',{staticClass:"aero-bubbles",attrs:{"aria-hidden":"true"}},_vm._l((_vm.bubbles),function(bubble){return _c('span',{key:bubble.id,staticClass:"aero-bubble",style:({
      left: bubble.left + '%',
      width: bubble.size + 'px',
      height: bubble.size + 'px',
      animationDuration: bubble.rise + 's',
      animationDelay: -bubble.delay + 's',
    })},[_c('span',{staticClass:"aero-bubble-film",style:({
        animationDuration: bubble.sway + 's',
        '--aero-sway': bubble.swayWidth + 'px',
      })})])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }